import { Klass, u_ } from "@pressmedia/webappbase";
import "./klass.VuwPager";

export default {
	/**
	 * 内包するVuwPagerの更新関数
	 *
	 * @param {*} offset
	 * @param {*} limit
	 * @param {*} total
	 * @returns Promise
	 */
	async updPager(offset, limit, total) {
		const vuwPager = this.get("pager");
		
		if( !(vuwPager instanceof Klass("VuwPager") ) ) {
			return Promise.reject({
				code: NaN,
				messages: [this.name + "has no pager."],
				method: "updPager"
			});
		}
		
		if(!this.module) {
			return Promise.reject({
				code: NaN,
				messages: [this.name + "has no module."],
				method: "updPager"
			});
		}
		
		u_.isNumber(offset) || (offset = 0);
		u_.isNumber(limit) || (limit = 0);
		u_.isNumber(total) || (total = 0);
		
		const state = {
			total: total,
			from: offset + 1,
			to: offset + limit
		};
		
		const { pageLimit, pagerLimit } = this.module.config;
		
		if(u_.isNumber(pageLimit) && pageLimit) {
			state.current = this.module.currentPage;
			state.length = Math.ceil(total / pageLimit);
			state.prevElm = this.module.app.config.pagerShiftPrevElm;
			state.nextElm = this.module.app.config.pagerShiftNextElm;
			
			state.fltr = { ...this.module.app._GET };
			if( Array.isArray(this.excludeQueryFromPager) ) {
				this.excludeQueryFromPager.forEach(query => {
					if(
						query &&
						u_.isString(query) &&
						u_.hasProperty(state.fltr, query)
					) {
						delete state.fltr[query];
					}
				});
			}
			
			if(u_.isNumber(pagerLimit) && pagerLimit) {
				state.limit = pagerLimit;
				state.center = Math.floor(state.limit / 2);
				
				if(state.current > state.center) {
					state.start = state.current - 1 - state.center;
					
					if(state.length < state.start + state.limit) {
						state.start = state.length - state.limit;
						(state.start < 0) && (state.start = 0);
					}
					
				} else {
					state.start = 0;
				}
				
				delete state.center;
			}
		}
		
		return vuwPager.setState(state);
	}
};
